
const validateName = (name: string) => {
  if((name + "").length > 2) {
    return true;
  }
  return false;
}

function alphabeticalSort(arr:string[]){
  let arrSorted = arr.sort((a,b) => {
    return a.trim().toLowerCase().localeCompare(b.trim().toLowerCase())
  })
  return arrSorted
}


const exportFunctions = {
   validateName, alphabeticalSort
};

export default exportFunctions;